import { useNavigate } from "react-router-dom";

import { Layout } from "../components/Layout";
import { LoginForm } from "../components/LoginForm";
import { ColleagueDetailsContext } from "contexts/ColleagueDetailsContext";
import { useContext } from "react";

export const Login = () => {
  const { fetchColleagueDetails } = useContext(ColleagueDetailsContext);

  const navigate = useNavigate();

  return (
    <Layout title="Colleague Portal">
      <LoginForm
        onSuccess={async () => {
          await fetchColleagueDetails();
          navigate("/main/home");
        }}
      />
    </Layout>
  );
};
